import en from "@gethere/locales/en/common.json";
import es from "@gethere/locales/es/common.json";
import fr from "@gethere/locales/fr/common.json";
import de from "@gethere/locales/de/common.json";
import he from "@gethere/locales/he/common.json";

export function getLangMessages(lang: string) {
  switch (lang) {
    case "de":
      return de;
    case "es":
      return es;
    case "fr":
      return fr;
    case "he":
      return he;
    default:
      return en;
  }
}
